import { isAxiosError } from "axios";
import { useEffect } from "react";
import { Navigate, useRouteError } from "react-router-dom";

import { removeAuthToken } from "@/core/auth/auth";
import { logoutSupportChatWidget } from "@/modules/support";
import { AuthorizationErrorView } from "atoms/AuthorizationErrorView";
import { FatalErrorView } from "atoms/FatalErrorView";
import { isAuthorizationError } from "utils/isAuthorizationError";
import { isDeactivatedAdminUserError } from "utils/isDeactivatedAdminUserError";
import { isDeactivatedPlatformError } from "utils/isDeactivatedPlatformError";
import { isPastDueLockedPlatformError } from "utils/isPastDueLockedPlatformError";
import { extractPlatformIdFromAxiosError } from "utils/extractPlatformIdFromRequestUrl";

export const ErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => console.error(error), [error]);

  if (isPastDueLockedPlatformError(error)) {
    const platformId = extractPlatformIdFromAxiosError(error);
    const search = platformId ? `?platformId=${encodeURIComponent(platformId)}` : "";
    return <Navigate to={`/past-due-locked${search}`} />;
  }

  if (isDeactivatedPlatformError(error)) {
    return <Navigate to="/deactivated-platform" />;
  }

  if (isDeactivatedAdminUserError(error)) {
    return <Navigate to="/deactivated-admin-user" />;
  }

  if (isAuthorizationError(error)) {
    return <AuthorizationErrorView />;
  }

  if (isAxiosError(error) && error.response?.status === 401) {
    globalThis.Appcues?.reset();
    logoutSupportChatWidget();
    removeAuthToken();
    return <Navigate to="/login?error=session_expired" />;
  }

  return <FatalErrorView />;
};
